export class LegalResult {
  domain!: string;
  summary!: string;
  terms_of_service!: string;
  robots_txt_restrictions!: string;
  license_terms!: string;
  jurisdictions: string[] = [];

  constructor(data: Partial<LegalResult> = {}) {
    Object.assign(this, data);
  }
}
